module.exports = "/assets/299dd126e6fbcf9484ef12ad3de573a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4W.png
// module id = 1048
// module chunks = 0